import React, { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { Heart, Play, Pause } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function ParentMessageCard({ msg }) {
  const { t } = useLanguage();
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);
  const audioSrc = msg.voice_path ? `${API}/encourage/${msg.id}/audio` : null;  return (
    <div className="rounded-2xl border border-gold-500/40 bg-gold-500/5 p-4" data-testid={`family-msg-${msg.id}`}>
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-full bg-gold-500/15 text-gold-600 grid place-items-center shrink-0">
          <Heart className="h-5 w-5 fill-gold-500 text-gold-500" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs uppercase tracking-[0.18em] text-gold-600 font-semibold">{t("familyMessages.from", { from_name: msg.from_name })}</div>
          <p className="mt-1.5 text-foreground/90 leading-relaxed">{msg.note}</p>
          {audioSrc && (
            <div className="mt-3 inline-flex items-center gap-2 px-3 py-2 rounded-full border border-gold-500/30 bg-white/70">
              <button onClick={() => { if (playing) audioRef.current?.pause(); else audioRef.current?.play(); }} className="p-1 rounded-full bg-forest-600 text-sand-100" data-testid={`family-play-${msg.id}`}>
                {playing ? <Pause className="h-3.5 w-3.5" /> : <Play className="h-3.5 w-3.5" />}
              </button>
              <audio ref={audioRef} src={audioSrc} preload="none"
                onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
              <span className="text-xs text-forest-700">{t("familyMessages.voiceMessage")}</span>
            </div>
          )}
          <div className="text-[11px] text-muted-foreground mt-2">{new Date(msg.created_at).toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
}

export default function FamilyMessages() {
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/feedback/me").then((r) => {
      const family = (r.data || []).filter((x) => x.kind === "parent_encourage");
      setItems(family);
    }).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="hifz-card" data-testid="family-messages">
      <div className="flex items-center gap-2 mb-1">
        <Heart className="h-4 w-4 text-gold-500 fill-gold-500" />
        <h2 className="font-display font-semibold text-lg text-forest-700">{t("familyMessages.fromYourFamily")}</h2>
      </div>
      <p className="text-sm text-foreground/65 mb-4">{t("familyMessages.personalEncouragementFromThoseWho")}</p>
      <div className="space-y-3">
        {items.slice(0, 3).map((m) => <ParentMessageCard key={m.id} msg={m} />)}
      </div>
    </section>
  );
}
